import { customElement, useView } from 'aurelia-templating';
import { widget } from '../../widgets/widget-decorator';
import { BindingEngine } from 'aurelia-binding';
import { WidgetBase } from '../widget-base';
import { CustomerService } from '../../services/customer-service';
import { PLATFORM } from 'aurelia-framework';
import { AlertService } from '@aurelia-toolkit/alert';
import { property } from '../property-decorator';
import { WidgetPropertyType } from '../widget-property-type';

@customElement('text-widget')
@useView(PLATFORM.moduleName('./text-widget.html'))
@widget('Text', true, true)
export class TextWidget extends WidgetBase {
  constructor(element: Element, customerService: CustomerService, bindingEngine: BindingEngine, public alertService: AlertService) {
    super(element, bindingEngine, customerService);
  }

  @property('Text', undefined, WidgetPropertyType.LargeText)
  text?: string;

  @property('Text')
  font?: string;

  @property('Text')
  fontSize?: number;

  @property('Text')
  fontWeight?: string;

  @property('Text')
  color?: string;

  @property('Text', 'Alignment', WidgetPropertyType.List, [{ value: 'left', label: 'Left' }, { value: 'center', label: 'Center' }, { value: 'right', label: 'Right' }])
  textAlign?: 'left' | 'center' | 'right';
}
